import { useMemo, useState } from 'react';
import { ClickOutsideDetector, IconDown, IconSelected, IconUp } from '@ui/src';
import { TransactionsType } from '../../hoc/dashboard/types';
import { TransactionsTypePickerTypes } from './types';

import cn from './dashboard.module.css';

const TransactionsTypePicker = ({
  transactionsType,
  setTransactionsType,
  // getValues,
  className,
}: TransactionsTypePickerTypes) => {
  const [transactionsTypeMenuVisible, setTransactionsTypeMenuVisible] =
    useState(false);

  const selectedType = useMemo(() => {
    let res: string;

    switch (transactionsType) {
      case TransactionsType.INCOMING:
        res = 'Incoming';
        break;
      case TransactionsType.OUTGOING:
        res = 'Outgoing';
        break;
      default:
        res = transactionsType || '';
        break;
    }
    return res;
  }, [transactionsType]);

  return (
    <ClickOutsideDetector
      setOptionsListVisible={
        setTransactionsTypeMenuVisible
      }
    >
      <div className={`${cn.dropdownWrapper} ${className || ''}`}>
        <button
          type="button"
          className={`${cn.dropdownButton} ${
            transactionsTypeMenuVisible ? cn.dropdownButtonActive : ''
          }`}
          onClick={() =>
            setTransactionsTypeMenuVisible &&
            setTransactionsTypeMenuVisible(!transactionsTypeMenuVisible)
          }
        >
          <div className={cn.dropdownButtonLeft}>
            <div className={cn.dropdownButtonValue}>{selectedType}</div>
          </div>
          <div className={cn.dropdownButtonRight}>
            {transactionsTypeMenuVisible ? <IconUp /> : <IconDown />}
          </div>
        </button>
        {transactionsTypeMenuVisible && (
          <ul className={cn.dropdownMenu}>
            <li className={cn.dropdownMenuTitle}>Select type</li>
            <li>
              <button
                type="button"
                className={cn.dropdownMenuButton}
                onClick={() => {
                  if (setTransactionsType) {
                    setTransactionsType(TransactionsType.INCOMING);
                  }

                  if (setTransactionsTypeMenuVisible) {
                    setTransactionsTypeMenuVisible(false);
                  }
                }}
              >
                <div className={cn.dropdownMenuButtonLeft}>
                  <div className={cn.dropdownMenuButtonValue}>Incoming</div>
                </div>

                {transactionsType === TransactionsType.INCOMING && (
                  <IconSelected />
                )}
              </button>
            </li>

            <li>
              <button
                type="button"
                className={cn.dropdownMenuButton}
                onClick={() => {
                  if (setTransactionsType) {
                    setTransactionsType(TransactionsType.OUTGOING);
                  }

                  if (setTransactionsTypeMenuVisible) {
                    setTransactionsTypeMenuVisible(false);
                  }

                  // getValues();
                }}
              >
                <div className={cn.dropdownMenuButtonLeft}>
                  <div className={cn.dropdownMenuButtonValue}>Outgoing</div>
                </div>
                {transactionsType === TransactionsType.OUTGOING && (
                  <IconSelected />
                )}
              </button>
            </li>
          </ul>
        )}
      </div>
    </ClickOutsideDetector>
  );
};

export default TransactionsTypePicker;
